import React from 'react';
import './App.css';
import start from './assets/start.png';
import question1 from './assets/question-1.png';
import question2 from './assets/question-2.png';
import question3 from './assets/question-3.png';
import question4 from './assets/question-4.png';
import question5 from './assets/question-5.png';

//Simulating data coming from axios

const questionsArray = [
    {
        question: 'What percentage of blocked pipes are caused by wet wipes?',
        option1: '40%',
        option2: '60%',
        option3: '80%',
        answerLetter: 'C',
        answer: '80%',
        fact: 'Wipes are involved in 80% of blocked pipes. Please\u00a0don\'t\u00a0flush\u00a0them. Always\u00a0bin\u00a0them.',
        image: question1
    },
    {
        question: 'What percentage of wet wipes currently sold contain plastic?',
        option1: '85%',
        option2: '90%',
        option3: '95%',
        answerLetter: 'B',
        answer: '90%',
        fact: '90% of wipes sold contain plastic, which clog pipes. That is why Scottish Water is campaigning to get plastic wipes banned.',
        image: question2
    },
    {
        question: 'Which of the following is it OK to flush down the loo?',
        option1: 'Left over spaghetti',
        option2: 'Wet wipes and make up removers',
        option3: 'Only the 3ps - paper, pee and poo',
        answerLetter: 'C',
        answer: 'Only the 3ps - paper, pee and poo',
        fact: 'Anything, other than the 3 P\'s (Pee, Poo, toilet Paper), should be put in the bin.',
        image: question3
    },
    {
        question: 'How should you dispose of fats, oil and grease?',
        option1: 'Pour it down the sink, followed by boiling water',
        option2: 'Let it cool and feed it to the birds',
        option3: 'Let it cool and scrape it into the bin (or food recycling if accepted by your local council)',
        answerLetter: 'C',
        answer: 'Let it cool and scrape it into the bin (or food recycling if accepted by your local council)',
        fact: 'When the fats, oil and grease cool, they congeal and stick to other rubbish in the sewer system, which can create disgusting fatbergs. You should let it cool and scrape it into the bin or food recycling.',
        image: question4
    },
    {
        question: 'Complete the line from our Nature Calls advertising campaign: When nature calls, there\'s a world to save. Please\u00a0bin\u00a0the\u00a0wipes and\u00a0join\u00a0the...',
        option1: 'Rave',
        option2: 'Wave',
        option3: 'Tide',
        answerLetter: 'B',
        answer: 'Wave',
        fact: '\'Join the wave\', to keep up to date with news, views and top tips that are good for you, your pocket, and the planet. Join today!',
        image: question5
    },
]
  
class App extends React.Component {
  
    constructor (props, context) {
        super(props, context)
        this.state = {
            showStart: true,
            showAnswer: false,
            currentQuestionIndex: 0,
            // score: 0,
            questions: [],
            answers: []
        }
    }
    
    componentDidMount() {
        this.setState({questions: questionsArray})
    }

    startQuiz() {
        this.setState({showStart: false})
    }
    
    showNextQuestion() {
        let incrementCurrentQuestionIndex = this.state.currentQuestionIndex + 1
        this.setState({currentQuestionIndex: incrementCurrentQuestionIndex})
        this.setState({showAnswer: false})
    }
    
    onChangeOption(value) {
        const { currentQuestionIndex } = this.state
        let answers = [...this.state.answers]
        // let questions = [...this.state.questions]
        answers[currentQuestionIndex] = value
        this.setState({ showAnswer: true, answers })

        // if ( answers[currentQuestionIndex] === questions[currentQuestionIndex].answer ) {
        //     this.setState({score: this.state.score + 1})
        // }
    }
    
    render() {
        const { questions, currentQuestionIndex, answers, showAnswer, showStart } = this.state

        if (showStart === true) {
            return (
                <div className="c-quiz">
                    <div className="c-quiz__bg-answer">
                        <header className="c-quiz__header c-wrapper">
                            <img className="c-quiz__img" src={ start } alt="" />
                            <h1 className="c-quiz__title">Nature Calls</h1>
                            <p className="c-quiz__lede">Take our two-minute quiz and discover what causes blocked drains and harms nature.</p>
                        </header>
                        <footer className="c-quiz__footer c-wrapper">
                            <button
                                className="c-quiz__btn"
                                data-variant="large"
                                onClick={() => this.startQuiz()}
                            >
                                Start quiz
                            </button>
                        </footer>
                    </div>
                </div>
            )
        }

        if (!questions.length) {
            return <div> Loading questions...</div>
        }
  
        if (currentQuestionIndex >= questions.length) {
            return (
                <div className="c-quiz">
                    <div className="c-quiz__bg-answer">
                        <header className="c-quiz__header c-wrapper">
                            <img className="c-quiz__img" src={ start } alt="" />
                            <h1 className="c-quiz__title">Thank you</h1>
                            <p className="c-quiz__lede">You have completed the quiz. Support Scottish Water's call for a ban on plastic wipes. Help protect our natural environment by clicking on the link below.</p>
                        </header>
                        <footer className="c-quiz__footer c-wrapper">
                            <a className="c-quiz__btn" data-variant="large" href="https://www.jointhewave.scot/ban/" target="_blank" rel="noreferrer">
                                Back the ban
                            </a>
                            <a className="c-quiz__btn" data-variant="large" href="https://www.yourwateryourlife.co.uk/watersaving/" target="_blank" rel="noreferrer">
                                Menu
                            </a>
                        </footer>
                    </div>
                </div>
            )
        }

        const { question, option1, option2, option3, answer, answerLetter, fact, image } = questions[currentQuestionIndex]
    
        return (
            <div className="c-quiz">
                    { showAnswer === true &&
                        <div className="c-quiz__bg-answer">
                            <div className="c-quiz__body c-wrapper">
                                <h1 className="c-quiz__title">
                                    { answers[currentQuestionIndex] === answer ?
                                        'Well done!' : 'Almost!'
                                    }
                                </h1>
                                <h2 className="c-quiz__subtitle">The correct answer is</h2>
                                <div className="c-quiz__answer">
                                    <div className="c-quiz__counter">
                                        { answerLetter }
                                    </div>
                                    { answer }
                                </div>
                                <div className="c-quiz__fact">
                                    <h3 className="c-quiz__fact-title">Did you know?</h3>
                                    {fact}
                                </div>
                            </div>
                            <footer className="c-quiz__footer c-wrapper">
                                <button className="c-quiz__btn" data-variant="small" onClick={() => this.showNextQuestion()}>
                                    Next
                                </button>
                            </footer>
                        </div>
                    }
                    { showAnswer === false &&
                        <div className="c-quiz__bg-question">
                            <header className="c-quiz__header c-wrapper">
                                <div className={`c-quiz__progress ${currentQuestionIndex === 4 && 'last-question'}`}>
                                    <div className="c-quiz__progress-bar" style={{width: ((currentQuestionIndex + 1 ) * 20) + '%'}}></div>
                                    <span>{currentQuestionIndex + 1}/{questions.length}</span>
                                </div>
                            </header>
                            <div className="c-quiz__body c-wrapper">
                                <div className="c-quiz__question">
                                    <img className="c-quiz__img" src={ image } alt="" />
                                    <p className="c-quiz__lede">{ question }</p>
                                    <ul className="c-quiz__answers">
                                        <li className="c-quiz__answer-wrapper">
                                            <label className="c-quiz__answer">
                                                <div className="c-quiz__counter">
                                                    A
                                                </div>
                                                <input type='radio'
                                                    className="c-quiz__answer-input"
                                                    checked={answers[currentQuestionIndex] === option1}
                                                    value={option1}
                                                    onChange={(evt) => this.onChangeOption(evt.target.value)}/>
                                                    {option1}
                                            </label>
                                        </li>
                                        <li className="c-quiz__answer-wrapper">
                                            <label className="c-quiz__answer">
                                                <div className="c-quiz__counter">
                                                    B
                                                </div>
                                                <input type='radio'
                                                    className="c-quiz__answer-input"
                                                    checked={answers[currentQuestionIndex] === option2}
                                                    value={option2}
                                                    onChange={(evt) => this.onChangeOption(evt.target.value)}/>
                                                    {option2}
                                            </label>
                                        </li>
                                        <li className="c-quiz__answer-wrapper">
                                            <label className="c-quiz__answer">
                                                <div className="c-quiz__counter">
                                                    C
                                                </div>
                                                <input type='radio'
                                                    className="c-quiz__answer-input"
                                                    checked={answers[currentQuestionIndex] === option3}
                                                    value={option3}
                                                    onChange={(evt) => this.onChangeOption(evt.target.value)}/>
                                                    {option3}
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    }
            </div>
        );
    }
  
}

export default App;
